import { Buffer } from 'buffer';
import { components } from 'react-select';

export function initFieldMap(fields){
    const m = {}
    fields?.forEach(field=>{
      if (field.Enabled){
        m[field.FieldName] = field
      }
    })
    return m
  }

 export function getEmailPrefix(email) {
    const parts = email.split('@');
    return parts.length > 1 ? parts[0] : email; // If '@' exists, return the part before it, else return the whole string
  }

 export function formatTime(durationInSeconds) {
      const hours = Math.floor(durationInSeconds / 3600);
      const minutes = Math.floor((durationInSeconds % 3600) / 60);
      const seconds = durationInSeconds % 60;
  
      let formattedTime = '';
  
      // Add hours component if it's non-zero
      if (hours > 0) {
          formattedTime += `${hours}:`;
      }
  
      // Add minutes component if it's non-zero or there are hours
      if (minutes >= 10 || hours > 0) {
          formattedTime += `${String(minutes).padStart(2, '0')}:`;
      } else {
        formattedTime += `${String(minutes).padStart(1, '0')}:`;
      }
  
      // Always add seconds component
      formattedTime += String(seconds).padStart(2, '0');
  
      return formattedTime;
  }
  
  // export function toUrlSafeBase64(input) {
  //   // return btoa(input) // standard Base64
  //     .replace(/\+/g, '-') // make URL-safe
  //     .replace(/\//g, '_')
  //     .replace(/=+$/, ''); // remove any trailing '='
  // }

  // export function fromUrlSafeBase64(encoded) {
  //   // Convert URL-safe base64 to standard base64
  //   const base64 = encoded
  //     .replace(/-/g, '+')
  //     .replace(/_/g, '/')
  //     .padEnd(encoded.length + (4 - encoded.length % 4) % 4, '=');
  
  //   return atob(base64); // Decodes to raw string
  // }

// Encode to Base64URL
export function toUrlSafeBase64(input) {
  return Buffer.from(input, 'utf-8')
    .toString('base64')               // standard base64
    .replace(/\+/g, '-')              // convert '+' to '-'
    .replace(/\//g, '_')              // convert '/' to '_'
    .replace(/=+$/, '');              // remove padding
}

// Decode from Base64URL
export function fromUrlSafeBase64(encoded) {
  const strBase64 = encoded
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(encoded.length + (4 - (encoded.length % 4)) % 4, '=');

  return Buffer.from(strBase64, 'base64').toString('utf-8');
}

export function getCurrentTimeString() {
  const now = new Date();

  const pad = (n) => n.toString().padStart(2, '0');

  const year = now.getFullYear();
  const month = pad(now.getMonth() + 1); // Months are zero-indexed
  const day = pad(now.getDate());

  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());
  const seconds = pad(now.getSeconds());

  return `${year}-${month}-${day} ${hours}.${minutes}.${seconds}`;
}

export function isNumberField(fieldType) {
  return fieldType === 'decimal' || fieldType === 'integer';
}

export const customSearchInput = (props) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
      {/* <FontAwesomeIcon icon={faSearch} /> */}
      <components.Input {...props} placeholder=" Search ..."/>
    </div>
  )
}

// Define a no-op MultiValueRemove component when readOnly is true
export const MultiValueRemove = (props) => {
  if (props.selectProps.readOnly) return null;
  return <components.MultiValueRemove {...props} />;
}


// Hide dropdown arrow when readOnly
export const DropdownIndicator = (props) => {
  if (props.selectProps.readOnly) return null;
  return <components.DropdownIndicator {...props} />;
};

// Hide the small separator bar next to arrow
export const IndicatorSeparator = (props) => {
  if (props.selectProps.readOnly) return null;
  return <components.IndicatorSeparator {...props} />;
};